export function generateKey() {
    const timestamp = Date.now().toString(36);
    const randomString = Math.random().toString(36).substring(2, 6);
    return timestamp + randomString;
}
